import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {Spinner} from "../../Spinner";
import {ShopifyLinkComponent} from "../../agency/link_acocunts/ShopifyLink";
import { withTranslation } from 'react-i18next';
import {UserModulesContext} from "../../../context/UserModulesContext";
import {ShopifyStoreField} from "./ShopifyStoreField";
import {ShopifyLinkRequest} from "./ShopifyLinkRequest";
import {detectSubdomainFromPublicUrl, extractSubdomainFromInput, subdomainIsValid} from "./shopifySubdomain";


class AddStoreFormClass extends Component {
    // Shopify por link de instalación (tanda 23/10): con el flag de la agencia, el OAuth de la app pública se
    // cambia por el pedido del link (`ShopifyLinkRequest`). Sin el flag, este formulario es el de siempre.
    static contextType = UserModulesContext;

    constructor(props) {
        super(props);

        this.state = {
            isSaving: false,
            storeSubdomain: null,
            detectedSubdomain: null,
            isDetecting: false,
            detectionError: null,
            inputValue: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleStoreSubdomainChange = this.handleStoreSubdomainChange.bind(this);
        this.handleStoreSubdomainBlur = this.handleStoreSubdomainBlur.bind(this);
        this.footerButton = this.footerButton.bind(this);
        this.processInput = this.processInput.bind(this);
    }

    async processInput(input) {
        if (!input || !input.trim()) {
            this.setState({
                detectedSubdomain: null,
                isDetecting: false,
                detectionError: null
            });
            return;
        }

        // Primero intentar extraer directamente
        const extractedSubdomain = extractSubdomainFromInput(input);

        if (extractedSubdomain) {
            // Caso 1 o 2: Ya tenemos el subdominio
            this.setState({
                detectedSubdomain: extractedSubdomain,
                isDetecting: false,
                detectionError: null
            });
            return;
        }

        // Caso 3: Necesitamos detectar desde URL pública
        this.setState({
            isDetecting: true,
            detectionError: null
        });

        try {
            const detectedSubdomain = await detectSubdomainFromPublicUrl(input);
            this.setState({
                detectedSubdomain: detectedSubdomain,
                isDetecting: false,
                detectionError: null
            });
        } catch (error) {
            this.setState({
                detectedSubdomain: null,
                isDetecting: false,
                detectionError: error.message || 'Error al detectar el subdominio'
            });
        }
    }

    handleStoreSubdomainChange(event) {
        const value = event.target.value;
        this.setState({
            inputValue: value,
            storeSubdomain: value,
            detectedSubdomain: null,
            detectionError: null
        });
    }

    handleStoreSubdomainBlur(event) {
        const value = event.target.value;
        if (value && value.trim()) {
            this.processInput(value);
        }
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({
            isSaving: true
        });
    }

    footerButton() {
        if (this.state.isSaving) {
            return <Spinner color="positive small"/>;
        }

        const subdomainToUse = this.state.detectedSubdomain || this.state.storeSubdomain;
        const trimmedSubdomain = subdomainToUse ? subdomainToUse.trim() : "";
        const isValid = subdomainIsValid(trimmedSubdomain);

        return <ShopifyLinkComponent hasConnection={false} subdomain={trimmedSubdomain} disabled={!isValid || this.state.isDetecting} />;
    }

    render() {
        if (this.context && this.context.shopifyInstallByLink === true) {
            return <ShopifyLinkRequest agencyClientId={this.props.clientId || null} onClose={this.props.onClose}/>;
        }

        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <ShopifyStoreField value={this.state.storeSubdomain}
                                           onChange={this.handleStoreSubdomainChange}
                                           onBlur={this.handleStoreSubdomainBlur}
                                           isDetecting={this.state.isDetecting}
                                           detectionError={this.state.detectionError}
                                           detectedSubdomain={this.state.detectedSubdomain}/>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.footerButton()}
                </ModalFooter>
            </form>
        )
    }
}

export const AddStoreForm = withTranslation()(AddStoreFormClass);
